import { createAction } from 'typesafe-actions'

export const showE3DSharingDashboard = createAction('DOC / E3DSharingDashboard / SHOW')()
export const hideE3DSharingDashboard = createAction('DOC / E3DSharingDashboard / HIDE')()
export const setShouldAutoDisplayE3DSharingDashboard = createAction('DOC / E3DSharingDashboard / SET_SHOULD_AUTO_DISPLAY')<boolean>()
